import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@src/store'
import { Profile } from '@src/types/user'
import { useAppSelector } from '@src/hooks'
import { DEFAULT_SIDEBAR_WIDTH } from '@src/config'

export type ProjectsState = {
  profile: Profile | null;
  existsNotifications: boolean;
  sidebarOpen: boolean;
  sidebarWidth: number;
}

const initialState: ProjectsState = {
  sidebarWidth: DEFAULT_SIDEBAR_WIDTH,
  existsNotifications: false,
  sidebarOpen: false,
  profile: null,
}

export const appState = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setProfile(state: Draft<ProjectsState>, { payload }: PayloadAction<Profile | null>) {
      state.profile = payload
    },
    setExistsNotifications(state: Draft<ProjectsState>, { payload }: PayloadAction<boolean>) {
      state.existsNotifications = payload
    },
    setSidebarWidth(state: Draft<ProjectsState>, { payload }: PayloadAction<number>) {
      state.sidebarWidth = payload
    },
    setSidebarOpen(state: Draft<ProjectsState>, { payload }: PayloadAction<boolean>) {
      state.sidebarOpen = payload
    },
  }
})

export const { setProfile, setExistsNotifications, setSidebarWidth, setSidebarOpen } = appState.actions
export default appState.reducer

export const useProfile = (): Profile | null => {
  return useAppSelector((state: RootState) => state.appState.profile)
}

export const useSidebarWidth = (): number => {
  return useAppSelector((state: RootState) => state.appState.sidebarWidth)
}

export const useSidebarOpen = (): boolean => {
  return useAppSelector((state: RootState) => state.appState.sidebarOpen)
}

export const useExistsNotifications = (): boolean => {
  return useAppSelector((state: RootState) => state.appState.existsNotifications)
}